import { UserTypes } from './user.types';

export const UPLOAD_IMAGES_LIMITS = {
  [UserTypes.Free]: 6,
  [UserTypes.Premium]: 50,
  [UserTypes.Education]: 50,
  [UserTypes.Business]: 500,
  [UserTypes.Enterprise]: 9999,
  [UserTypes.Admin]: 9999,
};
